// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function MM_cmp_asrts_per_page(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var initAsrtsPerPage = props.initAsrtsPerPage;
  var match = React.useState(function () {
        return initAsrtsPerPage;
      });
  var setAsrtsPerPage = match[1];
  var asrtsPerPage = match[0];
  var actOk = function (param) {
    Curry._1(onOk, asrtsPerPage);
  };
  var actCancel = function (param) {
    Curry._1(onCancel, undefined);
  };
  var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actCancel, undefined);
  var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actOk, undefined);
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: asrtsPerPage,
                            label: "Assertions per page",
                            size: "small",
                            style: {
                              width: "150px"
                            },
                            onChange: (function (param) {
                                return Expln_React_common.evt2str((function (str) {
                                              Curry._1(setAsrtsPerPage, (function (param) {
                                                      return str;
                                                    }));
                                            }), param);
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                              }),
                            autoFocus: true
                          }), React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onOk, asrtsPerPage);
                                  }),
                                variant: "contained",
                                children: "Ok"
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onCancel, undefined);
                                  }),
                                children: "Cancel"
                              }))))
            });
}

var make = MM_cmp_asrts_per_page;

exports.make = make;
/* react Not a pure module */
